import script from "./PostgraEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostgraEdit.vue?vue&type=script&lang=ts&setup=true"

import "./PostgraEdit.vue?vue&type=style&index=0&id=1f0d0270&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f0d0270"]])

export default __exports__